import React from 'react';
import { sitesUrls } from "§/src/utils/sitesUrls";

const SchemaPost = ({ post, cptPosts }) => {
  const currentLang = process.env.GATSBY_SITE_LANG;
  const siteInfo = sitesUrls(currentLang);

  // Function to get the full image URL
  const getFullImageUrl = (imageUrl) => {
    if (!imageUrl) return "";
    if (imageUrl.startsWith("http")) return imageUrl;
    return `${siteInfo.url}${imageUrl}`;
  };

  // Function to format date to YYYY-MM-DD
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `${siteInfo.url}${post.uri}`
    },
    "headline": post.title,
    "image": getFullImageUrl(cptPosts?.mainImage?.gatsbyImage?.images?.fallback?.src),
    "author": {
      "@type": "Organization",
      "name": "Gefran"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Gefran",
      "logo": {
        "@type": "ImageObject",
        "url": `${siteInfo.url}/logo.png`
      }
    },
    "datePublished": formatDate(post?.seo?.opengraphPublishedTime),
    "dateModified": formatDate(post?.seo?.opengraphModifiedTime)
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schemaData)}
    </script>
  );
};

export default SchemaPost;
